import { type ReactNode } from 'react'
import type { Course } from '@mc/api'
import { ErrorBoundary } from '@mc/error-boundary'
import Experiment from '@mc/experiments-react'
import { useStaticData } from '@mc/static-data-react'
import { EXPERIMENT_FLAG, isExcludedSlug } from '../constants'
import styles from './BelowHeroWrapper.module.scss'

interface BelowHeroWrapperProps {
  Control: ReactNode
}

export const BelowHeroWrapper = ({ Control }: BelowHeroWrapperProps) => {
  const { course } = useStaticData<{ course: Course }>()

  if (isExcludedSlug(course?.slug))
    return <ErrorBoundary>{Control}</ErrorBoundary>

  return (
    <Experiment
      name={EXPERIMENT_FLAG}
      control={() => Control}
      // Marker: drops <main>'s 100dvh min-height so the footer follows the hero
      variant_1={() => <div className={styles.heroOnly} />}
      track={false}
    />
  )
}
